import { allAvailableEventTypes, VISIT_EVENT_TYPES } from 'src/consumer/constants'

export function getOfflineRegularEvents(events) {
  return events?.filter(
    (item) => item?.meetingSrc === 'offline' && item?.visitEventType === VISIT_EVENT_TYPES.regular,
  )
}
export function getOnlineRegularEvents(events) {
  return events?.filter(
    (item) => item?.meetingSrc === 'aumhum' && item?.visitEventType === VISIT_EVENT_TYPES.regular,
  )
}

export function getClinicPublicallyListableEvents(eventTypes, clinicId) {
  return eventTypes?.filter(
    (item) =>
      item?.contextId === clinicId &&
      item?.enabled &&
      !item?.free &&
      item?.type !== allAvailableEventTypes.screening &&
      Boolean(item?.publicEvent),
  )
}
